import React, { useState, useEffect } from 'react';
import { Jumbotron, Container } from 'react-bootstrap';
import '../Styles/GenericPage.css';
import axios from 'axios';
import {Line} from 'react-chartjs-2';

let googleSheetKey = 'AIzaSyA1Xlxu7lcp2pgNcN_bbaJLuf8VB3yQzNg';
let spreadSheetId = '1fmLLAQH7tC288WJ06hneD7bX7u5hAGg4uk7z_L0x9NQ';

function WellInfo(props) {
  console.log('hello props ', props);
  let [chartValues, setValues] = useState([]);
  let [chartLabels, setLabels] = useState([]);
  let data = {
    labels: chartLabels,
    datasets: [
      {
        label: 'Test Data Set',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 5,
        pointHitRadius: 20,
        data: chartValues
      }
    ]
  };

  useEffect(() => {
  let url = `https://sheets.googleapis.com/v4/spreadsheets/${spreadSheetId}/values/Sheet1!A1:B?key=${googleSheetKey}`;
  axios.get(url)
    .then(res => {
      let arrLabels = [];
      let arrValues = [];
      for (let index = 1; index < res.data.values.length; index++) {
        const item = res.data.values[index];
        arrLabels.push(item[0]);
        arrValues.push(item[1]);
      }
      setLabels(arrLabels);
      setValues(arrValues);
    })
    .catch(err => {console.error(err)})
  }, []);

  console.log(props.location.appState.detail.name)
  return (
    <div>
      <div>
          {/* <Jumbotron id="genericJumbo">
          </Jumbotron> */}
          <Container>
              <h2>{props.location.appState.detail.name} D/W Levels</h2>
              <Line data={data}/>
          </Container>
      </div>
    </div>
  );
}

export default WellInfo;